const skills = [
  // Languages
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
    altText: "JavaScript",
    title: "JavaScript"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
    altText: "TypeScript",
    title: "TypeScript"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg",
    altText: "C",
    title: "C"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg",
    altText: "C++",
    title: "C++"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg",
    altText: "Python",
    title: "Python"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
    altText: "HTML",
    title: "HTML"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
    altText: "CSS",
    title: "CSS"
  },
  // Frontend & Backend Frameworks
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
    altText: "NodeJS",
    title: "NodeJS"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg",
    altText: "ExpressJS",
    title: "ExpressJS"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nestjs/nestjs-original.svg",
    altText: "NestJS",
    title: "NestJS"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
    altText: "ReactJS",
    title: "ReactJS"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg",
    altText: "Flask",
    title: "Flask"
  },
  // Databases & ORMs
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
    altText: "MySQL",
    title: "MySQL"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
    altText: "PostgreSQL",
    title: "PostgreSQL"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
    altText: "MongoDB",
    title: "MongoDB"
  },
  {
    imageSrc: "https://api.iconify.design/logos:aws-documentdb.svg",
    altText: "DocumentDB",
    title: "DocumentDB"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg",
    altText: "CosmosDB",
    title: "CosmosDB"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg",
    altText: "Redis",
    title: "Redis"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sequelize/sequelize-original.svg",
    altText: "Sequelize",
    title: "Sequelize"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongoose/mongoose-original.svg",
    altText: "Mongoose",
    title: "Mongoose"
  },
  // Cloud & Messaging
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-plain-wordmark.svg",
    altText: "AWS",
    title: "AWS"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg",
    altText: "Azure",
    title: "Azure"
  },
  {
    imageSrc: "https://api.iconify.design/logos:aws-s3.svg",
    altText: "S3",
    title: "S3"
  },
  {
    imageSrc: "https://api.iconify.design/logos:aws-sqs.svg",
    altText: "SQS",
    title: "SQS"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apachekafka/apachekafka-original-wordmark.svg",
    altText: "Kafka",
    title: "Kafka"
  },
  // DevOps, Tools & Systems
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
    altText: "Docker",
    title: "Docker"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg",
    altText: "Kubernetes",
    title: "Kubernetes"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
    altText: "Git",
    title: "Git"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gitlab/gitlab-original.svg",
    altText: "GitLab",
    title: "GitLab"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg",
    altText: "Jenkins",
    title: "Jenkins"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bitbucket/bitbucket-original.svg",
    altText: "Bitbucket",
    title: "Bitbucket"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/linux/linux-original.svg",
    altText: "Linux",
    title: "Linux"
  },
  {
    imageSrc: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apache/apache-original.svg",
    altText: "Apache",
    title: "Apache"
  }
];

export default skills;
